import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, NavParams, Events } from 'ionic-angular';
import { Validators, FormBuilder } from '@angular/forms';
import { UserEditPage } from '../../pages/user-edit/user-edit';
import { UserRegisterPage } from '../../pages/user-register/user-register';
import { AuthData } from '../../providers/auth';
import { Translate } from '../../providers/translate';
import { UserData } from '../../providers/user';
import { Tracking } from '../../providers/tracking';
import { EmailValidator } from '../../validators/email';

@Component({
  selector: 'social-login',
  templateUrl: 'social-login.html'
})
export class SocialLoginComponent {

	/**
	 * login component
	 * @description: TODO
	 *
	 * @param nvctrl
	 */

	toastError: any;
	loginEmailForm: any;
	loginEmailData: any;
	loginTokenForm: any;
	loginTokenData: any;
	client: any;
	event: any;
	textTranslate: any;
	redirect: any;

  constructor(public navCtrl: NavController, private formBuilder: FormBuilder, public params: NavParams, public userProvider: UserData, public auth: AuthData, public toastCtrl: ToastController, public loading: LoadingController, public t: Tracking, public translate: Translate, public events: Events) {
		this.client = this.params.get('client');
		this.event = this.params.get('event');
		this.redirect = params.get('redirect');

		this.translate.translateGroup(['Ha iniciado se sesión como', 'Autenticando', 'No se ha podido acceder a la cuenta en este momento', 'El usuario ya se encuentra asociado con otras credenciales', 'No hemos detectado una conexión a internet', 'El correo electrónico ingresado es inválido', 'El usuario se encuentra inhabilitado', 'Nombre de usuario o contraseña incorrectos'])
		.then(result => {
			this.textTranslate = result;
		});

		// ##################################

		// For type login email
		this.loginEmailData = {
			email: '',
			password: ''
		};

    this.loginEmailForm = this.formBuilder.group({
      email: ['', Validators.compose([EmailValidator.isValid, Validators.required])],
      password: ['', Validators.required]
    });

		// ##################################

		// For type login token
		this.loginTokenData = {
			token: ''
		};

    this.loginTokenForm = this.formBuilder.group({
      token: ['', Validators.required]
    });
	}

	loginSocial(provider) {
		let loader = this.loading.create({
			content: this.textTranslate['Autenticando'],
			dismissOnPageChange: true
		});
		loader.present();

		switch (provider) {
			case 'facebook':
				this.auth.loginFacebook()
				.then((user: any) => {
					// Search user in database
					this.userProvider.getProfile(this.client, user.user)
					.then((userProfile: any) => {
						let toast = this.toastCtrl.create({
							message: this.textTranslate['Ha iniciado se sesión como'] + ' ' + userProfile.name,
							position: 'top',
							showCloseButton: true,
							closeButtonText: this.textTranslate['Ok'],
							duration: 5000
						});

						if (this.redirect == 'event') {
							// TODO: rediect review
						} else {
							this.navCtrl.pop();
						}

						this.events.publish('client:logout', true);

						loader.dismiss();
						toast.present();
					})
					.catch((error) => {
						if (this.redirect != 'event') {
							// User no register in data base. redirect to register end
							this.navCtrl.push(UserEditPage, {origin: 'social-login-facebook', user: user.user, type: 'login', client: this.client, event: this.event});
						}
					});
				})
				.catch((error: any) => {
					this.errorSocialLogin(error);
					loader.dismiss();
				});
			break;

			case 'google':
				this.auth.loginGoogle()
				.then((user: any) => {
					// Search user in database
					this.userProvider.getProfile(this.client, user.user)
					.then((userProfile: any) => {
						let toast = this.toastCtrl.create({
							message: this.textTranslate['Ha iniciado se sesión como'] + ' ' + userProfile.name,
							position: 'top',
							showCloseButton: true,
							closeButtonText: this.textTranslate['Ok'],
							duration: 5000
						});

						if (this.redirect == 'event') {
							// TODO: rediect review
						} else {
							this.navCtrl.pop();
						}

						this.events.publish('client:logout', true);

						loader.dismiss();
						toast.present();
					})
					.catch((error) => {
						if (this.redirect != 'event') {
							// User no register in data base. redirect to register end
							this.navCtrl.push(UserEditPage, {origin: 'social-login-google', user: user.user, type: 'login', client: this.client, event: this.event});
						}
					});
				})
				.catch((error: any) => {
					this.errorSocialLogin(error);
					loader.dismiss();
				});
			break;

			case 'twitter':
				this.auth.loginTwitter()
				.then((user: any) => {
					// Search user in database
					this.userProvider.getProfile(this.client, user.user)
					.then((userProfile: any) => {
						let toast = this.toastCtrl.create({
							message: this.textTranslate['Ha iniciado se sesión como'] + ' ' + userProfile.name,
							position: 'top',
							closeButtonText: this.textTranslate['Ok'],
							showCloseButton: true,
							duration: 5000
						});

						if (this.redirect == 'event') {
							// TODO: rediect review
						} else {
							this.navCtrl.pop();
						}

						this.events.publish('client:login', user);

						loader.dismiss();
						toast.present();
					})
					.catch((error) => {
						console.log('no encontre al usuario')
						if (this.redirect != 'event') {
							// User no register in data base. redirect to register end
							this.navCtrl.push(UserEditPage, {origin: 'social-login-twitter', user: user.user, client: this.client, event: this.event});
						}
					});
				})
				.catch((error: any) => {
					this.errorSocialLogin(error);
					loader.dismiss();
				});
			break;
		}
	}

	errorSocialLogin(error) {
		let msg: any;

		switch(error.code) {
			case 'auth/internal-error':
				msg = this.textTranslate['No se ha podido acceder a la cuenta en este momento'];
				this.t.trackError('Auth', error.code);
			break;
			case 'auth/account-exists-with-different-credential':
				msg = this.textTranslate['El usuario ya se encuentra asociado con otras credenciales'];
			break;
			case 'auth/network-request-failed':
				msg = this.textTranslate['No hemos detectado una conexión a internet'];
			break;
			case 'auth/unauthorized-domain':
				msg = this.textTranslate['No se ha podido acceder a la cuenta en este momento'];
			break;
			case 'auth/popup-closed-by-user':
				msg = this.textTranslate['No se ha podido acceder a la cuenta en este momento'];
			break;
			default:
				msg = this.textTranslate['No se ha podido acceder a la cuenta en este momento'];
				// msg = error.code;
		}

		// msg = this.textTranslate['No hemos detectado una conexión a internet'];

		if (this.toastError) {
			this.toastError.dismiss();
			this.toastError = false;
		}

		this.toastError = this.toastCtrl.create({
			message: msg,
			duration: 4000
		});

		this.toastError.present();
	}

	loginEmail() {
		if (this.loginEmailForm.valid) {
			let loader = this.loading.create({
				content: this.textTranslate['Autenticando'],
				dismissOnPageChange: true
			});

			loader.present();

			this.auth.loginUser(this.loginEmailData.email, this.loginEmailData.password)
			.then((user: any) => {
				// Search user in database
				this.userProvider.getProfile(this.client, user)
				.then((userProfile: any) => {
					let toast = this.toastCtrl.create({
						message: this.textTranslate['Ha iniciado se sesión como'] + ' ' + userProfile.name,
						position: 'top',
						showCloseButton: true,
						closeButtonText: this.textTranslate['Ok'],
						duration: 5000
					});

					if (this.redirect == 'event') {
						// TODO: rediect review
					} else {
						this.navCtrl.pop();
					}

					this.events.publish('client:logout', true);

					loader.dismiss();
					toast.present();
				})
				.catch((error) => {
					if (this.redirect != 'event') {
						// User no register in data base. redirect to register end
						this.navCtrl.push(UserEditPage, {origin: 'social-login-email', client: this.client, user: user});
					}
				});

			})
			.catch((error) => {
				let msg: any;
				switch(error.code) {
					case 'auth/invalid-email':
						msg = this.textTranslate['El correo electrónico ingresado es inválido'];
					break;
					case 'auth/user-disabled':
						msg = this.textTranslate['El usuario se encuentra inhabilitado'];
					break;
					case 'auth/user-not-found':
					case 'auth/wrong-password':
						msg = this.textTranslate['Nombre de usuario o contraseña incorrectos'];
					break;
					default:
						msg = error;
						this.t.trackError('Auth', error);
				}

				if (this.toastError) {
					this.toastError.dismiss();
					this.toastError = false;
				}
				this.toastError = this.toastCtrl.create({
					message: msg,
					duration: 4000
				});

				this.loginEmailData.password = '';
				this.toastError.present();

				loader.dismiss();
			});
		}
	}

	loginToken() {

	}

	forgot() {

	}

	register() {
		this.navCtrl.push(UserRegisterPage, {origin: 'register', client: this.client, event: this.event});
	}
}
// TODO: Login Email
// TODO: Login Token
// TODO: Link various
// TODO: Forgot password
// TODO: Encrypt password transport
// TODO: catch errorSocialLogin function
// TODO: Verified data register required for abandoned register user
// end file



// WEBPACK FOOTER //
// ./src/components/social-login/social-login.ts